module.exports = __webpack_public_path__ + "img/8-min.4f43579b.jpg";